// todo url redicturl
import queryString from 'query-string';
import { isInZhuzher, isLocal } from './env';
import { isString } from './index';

// 缓存url token相关信息，方便开发
const URL_TOKEN_LOCAL_STORAGE_KEY = 'URL_TOKEN_LOCAL_STORAGE_KEY';
interface IQueryOfURL {
  (search?: Location['search'], useDecode?: boolean): {
    [p: string]: string | undefined;
  };
}
/**
 * 解析url里面的key
 */
export const queryOfURL: IQueryOfURL = (
  search = location.search,
  useDecode = true,
) => {
  // eslint-disable-next-line no-restricted-globals
  const params = queryString.parse(search);
  // eslint-disable-next-line no-shadow
  const decodeParams = (params: { [p: string]: any }) => {
    // decodeURIComponent
    const p: { [p: string]: any } = {};
    Object.keys(params).forEach(k => {
      const v = params[k];
      if (isString(v)) {
        if (useDecode) {
          p[k] = decodeURIComponent(v);
        } else {
          p[k] = v;
        }
      }
    });
    return p;
  };

  const p = decodeParams(params);

  return p;
};

type ITokenKey =
  | 'accessToken'
  | 'tokenType'
  | 'tokenHeaderKey'
  | 'backUrl'
  | 'at';

interface ITokenOfURL {
  (search: Location['search']): {
    [p in ITokenKey]: string | undefined;
  };
}
/**
 * 返回token使用的固定的url key
 * @param search
 */
export const tokenOfUrl = (search: Location['search']) => {
  const p = queryOfURL(search);
  let res = {
    accessToken: p.accessToken || p.at,
    tokenType: p.tokenType,
    tokenHeaderKey: p.tokenHeaderKey,
    backUrl: p.backUrl,
  };

  if (p.accessToken || p.at) {
    // 缓存token 方便其他页面使用
    if (isLocal) {
      localStorage.setItem(URL_TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(res));
    } else {
      sessionStorage.setItem(URL_TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(res));
    }
  } else {
    try {
      // 其次取缓存 token
      const localStorageToken = JSON.parse(
        (isLocal
          ? localStorage.getItem(URL_TOKEN_LOCAL_STORAGE_KEY)
          : sessionStorage.getItem(URL_TOKEN_LOCAL_STORAGE_KEY)) || '',
      );
      if (!isInZhuzher && localStorageToken) {
        res = localStorageToken;
      }
    } catch {
      // do nothing
    }
  }

  return res;
};
